module.exports = __webpack_public_path__ + "static/media/17.37211cf9.svg";